// Small utility for the "trusted device" flow.
// Generates & persists a per-browser device_id in localStorage. The value is
// treated purely as an opaque token by the backend — the server only trusts
// entries it explicitly added via /auth/pin/verify with trust_device=true.

const KEY = "lectura_device_id";

// base64url-safe random ID (matches server-side _b64url_ok validation)
const _random = () => {
  const bytes = new Uint8Array(18);
  crypto.getRandomValues(bytes);
  let s = "";
  for (let i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
  return btoa(s).replace(/=+$/, "").replace(/\+/g, "-").replace(/\//g, "_");
};

export const getDeviceId = () => {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = _random();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // Private mode / storage blocked — fall back to session-only id
    return _random();
  }
};

// Best-effort human-readable label for the SecurityCard list & PIN dialog
export const guessDeviceLabel = () => {
  const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
  const os = /iPhone/.test(ua) ? "iPhone"
           : /iPad/.test(ua) ? "iPad"
           : /Android/.test(ua) ? "Android"
           : /Mac/.test(ua) ? "Mac"
           : /Windows/.test(ua) ? "Windows PC"
           : /Linux/.test(ua) ? "Linux"
           : "This device";
  const browser = /Edg\//.test(ua) ? "Edge"
                : /OPR\//.test(ua) ? "Opera"
                : /Firefox/.test(ua) ? "Firefox"
                : /Chrome/.test(ua) ? "Chrome"
                : /Safari/.test(ua) ? "Safari"
                : "";
  return browser ? `${os} · ${browser}` : os;
};
